module.exports = __webpack_public_path__ + "img/live-state-icon-playing.48d2aa5.gif";